import React from 'react';
import Button from '../shared/Button';

const SSOLoginButton = ({ onClick, isLoading }) => {
  return (
    <Button
      className="sso-button"
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <span className="loading-spinner">⟳</span>
          Signing in...
        </>
      ) : (
        <>
          <span className="sso-icon">🔐</span>
          Sign on with SSO
        </>
      )}
    </Button>
  );
};

export default SSOLoginButton;
